/* @generated */

// src/assets/ui-icon/line/syncing.tsx
import * as React from "react";
var SyncingLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M8.5 9V7.5H6.771c1.062-1.338 2.796-2 5.229-2 4.374 0 6.5 2.126 6.5 6.5H20c0-5.159-2.841-8-8-8-2.973 0-5.169.95-6.5 2.74V4.5H4V9h4.5Zm7 6v1.5h1.729c-1.062 1.338-2.795 2-5.229 2-4.374 0-6.5-2.126-6.5-6.5H4c0 5.159 2.841 8 8 8 2.973 0 5.169-.95 6.5-2.74v2.24H20V15h-4.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  SyncingLine
};
